module.exports = __webpack_public_path__ + "img/Icon-Exhibit.e0c10036.svg";